










































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import { UsageQueryResult } from '@/agiles/common';
// import {Utils} from 'msal/lib-commonjs/Utils';

@Component
export default class App extends Vue {
  public isLoading: boolean = true;
  public isSideMenu: boolean = true;
  public langEnabled:boolean = true;
  public tours: Common.ProductTour[] = new Array();

  public userDescription:string = '';
  public operationDescription:string = '';
  public permission_error:boolean = false;
  public permission_error_msg:string = null;  
  get window(){
    return window;
  }
  onTourClick(tour: Common.ProductTour){
    if (tour.path && this.$route.path != tour.path) this.$router.push(tour.path,()=>{ (window as any).Intercom('startTour',tour.tourId);},null);    
    else  (window as any).Intercom('startTour',tour.tourId);    
  }
  clickHelp1(){
      this.$api.issueGA4trackevent(this.$route.path,'【サポートセンター】ボタン押下');
      window.open('https://support.s-flow.net/ja/','_blank');    
      // window.open('https://help.s-flow.net/implementation/','_blank');
  }
  clickHelp2(){
      window.open('https://help.s-flow.net/operation/','_blank');
  }  
  clickMovies() {
    this.$api.issueGA4trackevent(this.$route.path,'【サポート動画】ボタン押下');
    window.open('https://support.s-flow.net/ja/articles/7983031','_blank');
  }
  launchTour(){
    //ランチャースライドをキックする
    (window as any).Appcues.show(process.env.VUE_APP_TOUR);
    // this.$router.push(this.$route.path + '?appcue=1733e123-22db-4d5f-ba28-39eafe7a25ff');
  }
  launchUsageDialog(roadmap:boolean){
    //利用状況照会ダイアログを開く
    let componentClass = Vue.extend(Components.UsageDialog);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          showRoadmap :roadmap,
          roadmapMessage :null,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);    

  }
  public get envname():string{
    if (process.env.VUE_APP_MODE) return process.env.VUE_APP_API;
    else null;
  }
  public get isAdminSite():boolean {
    return this.$route.path.startsWith("admin");
  }  
  roadmapRatio:number = null;
  isPreparationCompleted = false;
  isRoadmapUpdated:boolean = false;
  created() {

    //api.tsでコンポーネントロードを回避(なんとなく)
    var router = this.$router;
    this.$api.handleMfaException = function(mode: Common.mfaFlags) {
        this.launchDialog(Components.Mfa, router, {'mode': mode}, document.body);  
    };

    //ログイン処理とマスタ初期化が完了したら画面を描画する
    this.$api.initialize().then(() => {
        this.isLoading = false;       

        this.onlyOpen = localStorage['onlyOpen'] == 'true';
        this.onlyOwned = this.$api.license.countOnlyOwned;        
        this.$api.setRoadmapRatio = (roadmap:Common.UsageQueryResult)=>{
          if (roadmap){
            if (this.roadmapRatio != roadmap.completedRatio || this.isPreparationCompleted != roadmap.isPreparationCompleted){
              this.roadmapRatio = roadmap.completedRatio;
              this.isPreparationCompleted = roadmap.isPreparationCompleted;
              this.isRoadmapUpdated = true;
            }
          } else {
            this.roadmapRatio = 0;
            this.isPreparationCompleted = false;
            this.isRoadmapUpdated = false;            
          }
          //トライアル早期離脱ユーザーの識別フラグ
          this.$api.earlyTrialStage = this.$api.license.isTrial && (this.isPreparationCompleted == false || this.roadmapRatio == 0);

          this.$forceUpdate;
        };
        this.$api.clearRoadmapAlert = ()=>{
          this.isRoadmapUpdated = false;
        };
        // 製品ツアーロード
        this.$api.execute(new Common.ProductTourQuery()).then(res =>{
          this.tours = (res as Common.LoadResult).result;
        });

        if(this.$api.license.isTrial){
          this.$api.execute(new Common.UsageQuery(Common.UsageCountType.Default)).then(obj =>{
            this.roadmapRatio = (obj as UsageQueryResult).completedRatio;
            this.isPreparationCompleted = (obj as UsageQueryResult).isPreparationCompleted;
            //トライアル早期離脱ユーザーの識別フラグ
            this.$api.earlyTrialStage = this.$api.license.isTrial && (this.isPreparationCompleted == false || this.roadmapRatio == 0);            
          });
              
        }

        //トライアル版のみグーグルタグマネージャーを挿入(製品HPとは別のタグマネージャ)=>利用状況分析のため有償利用にも適用
        let gtm = document.createElement('script');
        gtm.innerText = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-N2L7JH8');";
        document.head.appendChild(gtm);        

        //チャットツールのロード
          //以下フレッシュチャットのロード処理
          // var tag = this.$api.license.isTrial ? "trial" : "application";
          // let script = document.createElement('script');
          // script.onload = () => {
          //   (window as any).fcWidget.init({
          //     // token: "1493306f-9aa1-46ea-b8f7-b64bc5393c8f",
          //     token:"3db9a928-4ce4-4d89-8925-ce2ba63d6ffa",
          //     host: "https://wchat.freshchat.com",
          //     siteId: tag,
          // 　 tags: [tag],	  
          //     faqTags : {
          //       tags : [tag],
          //       filterType:'article'
          //       },                 
          //     config: {
          //       content: {
          //         headers: {
          //           chat: 'サポート窓口(平日 9:30～18:30)',
          //         }
          //       }                
          //     },
          //     externalId: this.$api.auth.userId,     // user’s id unique to your system
          //     firstName: this.$api.auth.userName,              // user’s first name

          //   });
          //   (window as any).fcWidget.on("widget:opened", function(resp : any) {
          //         (window as any).fcWidget.user.setProperties({
          //           "URL": window.location.href,});
          //   });            
          // };      
          // script.async = true
          // script.src = 'https://wchat.freshchat.com/js/widget.js'
          // document.head.appendChild(script);                

          const dayname = ['日','月','火','水','木','金','土'];
          // 有償登録日の2週間後
          let paidStartDate2Week = this.$api.license.paidStartDate ? new Date(this.$api.license.paidStartDate.getTime()) : null;
          if(paidStartDate2Week) paidStartDate2Week.setDate(paidStartDate2Week.getDate() + 14);
          // 有償登録日の24週間後
          let paidStartDate4Week = this.$api.license.paidStartDate ? new Date(this.$api.license.paidStartDate.getTime()) : null;
          if(paidStartDate4Week) paidStartDate4Week.setDate(paidStartDate4Week.getDate() + 28);

          (window as any).intercomSettings = {
            app_id: 'e1fkao87',
            name: this.$api.auth.userName, // 氏名に変更
            email: this.$api.auth.userId, // Email address
            user_id: this.$api.auth.userId, 
            created_at: Math.floor(this.$api.license.signupTimestamp.getTime()/1000), //サインアップ日時を上書き
            company:{company_id: this.$api.license.tenantId, name:this.$api.license.tenantName, Plan:this.$api.license.isTrial ? 'Trial':'Paid'},
            TenantAdmin: this.$api.license.isTenantAdmin, //インターコム側で管理者判定が必要
            PaidStartDate: this.$api.license.paidStartDate,
            Limit1: paidStartDate2Week ? (paidStartDate2Week.getMonth() + 1 ) + '月' + paidStartDate2Week.getDate() + '日 (' + dayname[paidStartDate2Week.getDay()] + ')' : '', //スタートアップ相談会の申込期限（有償利用開始日の2週間後）
            Limit2: paidStartDate4Week ? (paidStartDate4Week.getMonth() + 1 ) + '月' + paidStartDate4Week.getDate() + '日 (' + dayname[paidStartDate4Week.getDay()] + ')' : ''  //帳票無料作成サービスの申込期限（有償利用開始日の4週間後）
          };

          let script = document.createElement('script');
          script.async = true
          script.src = 'https://widget.intercom.io/widget/e1fkao87';
          document.head.appendChild(script);      

          //セッションレコーディング
          if(this.$api.enviromentFlag==Common.enviromentFlags.production && this.$api.license.isTrial){
            let smartlook = document.createElement('script');
            smartlook.type='text/javascript';
            const userName = String.format('{0}({1})', this.$api.license.tenantName,this.$api.license.user ? this.$api.license.user.name : this.$api.license.loginName);
            const userId = this.$api.license.user ? this.$api.license.user.id : this.$api.license.loginName;
            const tenantName = this.$api.license.tenantName;
            const tenantURL = String.format("https://{0}.s-flow.net", this.$api.license.tenantId);
            smartlook.innerHTML = `window.smartlook||(function(d) {
              var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
              var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
              c.charset='utf-8';c.src='https://rec.smartlook.com/recorder.js';h.appendChild(c);
              })(document);
              smartlook('init', '83138da9e090d5513c0cbd07ea4c56643668abc1');
              smartlook('identify', '${userId}', {"name": '${userName}',"tenant": '${tenantName}',"url": '${tenantURL}'});
              `;
            document.head.appendChild(smartlook);     
          }
          //チュートリアルツール用のスクリプトタグ
          // let appcues = document.createElement('script');
          // appcues.type='text/javascript';
          // appcues.src = '//fast.appcues.com/92041.js';
          // appcues.async = true;
          // appcues.onload = ()=>{
          //   //ユニークユーザーでカウントされるため要設定
          //   (window as any).Appcues.identify(this.$api.auth.userId);
          // };
          // document.head.appendChild(appcues);     

        // }
        // ライセンスによって表示項目を制御する
        this.langEnabled  = this.$api.hasLicense(Common.licenseFlags.currency);
        //

        var resizeHandler = ()=>{
          //2025.08.12 spModeは携帯OSに限定
          var isMobile = (/iPhone|iPad|iPod/.test(navigator.userAgent)) || (/android/i.test(navigator.userAgent));
          this.$api.spMode = isMobile && window.outerWidth < 1280 ? true : false;    //1280px以下をspModeとし、bodyにcx_spmodeを追加する             
          this.userDescription = window.outerWidth > 1450 ? this.$api.auth.userId: null;
          this.operationDescription = window.outerWidth > 1450 || this.$api.spMode  ? '運用情報': null;      
          document.documentElement.style.setProperty('--vh', window.innerHeight + 'px');

          this.$api.innerHeight = window.innerHeight;
        };

        resizeHandler();
        window.addEventListener('resize',resizeHandler);

      //初回アクセス時はonChange未設定なので直接呼び出す

      
        this.$api.perms.setPermissionMessage = this.setPermissionMessage; 
        // if (this.$api.perms.validateURL(null) == false) this.$router.push('/');

       //Lambaサービスを使用してbaseURLをCookieに設定する=>targetURLのドメインcookieに設定したい
       var targetURL = this.$api.enviromentFlag == Common.enviromentFlags.production ? "https://4cqtvy7z4lsx56qke6fkqozafq0nfujj.lambda-url.ap-northeast-1.on.aws/appURL" : this.$api.enviromentFlag == Common.enviromentFlags.staging ? "https://y3bhdtovot2nwhsmqmukxxgexy0gclkt.lambda-url.ap-northeast-1.on.aws/appURL" : "http://localhost:5002/appURL";
       var form = new FormData();
       form.append("appURL",location.host);
       form.append("appUser",this.$api.auth.userId);       
       navigator.sendBeacon(targetURL,form);

      });

    //ダイアログEditorの初期値を設定する=>廃止
    // if(localStorage['dialogEditorPreference'] == null)localStorage.setItem('dialogEditorPreference','true');    
    // this.$api.dialogEditorPreference = localStorage.getItem('dialogEditorPreference') == 'true';
    this.$api.dialogEditorPreference = true;
  }
  mounted(){

  }
  updated(){

  }
  setPermissionMessage(msg :string){
    this.permission_error_msg = msg;
    this.permission_error = true;
  }

  @Watch('permission_error')
  onPermissionErrorChange(){
    if (this.permission_error == false) this.permission_error_msg = null;
  }

  public onlyOpen:boolean = false;
  @Watch('onlyOpen')
  onOnlyOpenChange(){
    localStorage['onlyOpen'] = this.onlyOpen;
  }  
  public onlyOwned: boolean = false;

  public item: Common.User;
  public showPersonal:boolean = false;
  public dialogEditorPreference:boolean = false;
  public showPersonalDialog(){
    // if(localStorage['dialogEditorPreference'] == null)localStorage.setItem('dialogEditorPreference','true');    
    // this.dialogEditorPreference = localStorage.getItem('dialogEditorPreference') == 'true';
    this.$api.execute(new Common.UserLoadQuery()).then(res => {
        this.item = res;
        this.showPersonal = true;
      });
  }  
  public onOk() {
    this.$api.update(this.item).then(obj => {
      this.$api.license.countOnlyOwned = obj.countOnlyOwned;
      this.onlyOwned = obj.countOnlyOwned;
      //廃止
      // localStorage.setItem('dialogEditorPreference',this.dialogEditorPreference ? 'true':'false');
      // this.$api.dialogEditorPreference = this.dialogEditorPreference;  //既存Viewに反映させる        
    });
  }

  public showMfaDialog(){
    this.$api.execute(new Common.MFASettingQuery()).then(result => { 
                if ((result as Common.MFASetting).authenticationFlag == Common.authenticationFlags.session) this.$api.handleMfaException(Common.mfaFlags.update_session);
                else this.$api.handleMfaException(Common.mfaFlags.update_sms);});    
  }

  public onIssueApiKey() {
    //ランダムな文字列を発行する
    this.item.apiKey = this.getUUID();
    (this.$refs.apiKey as Vue).$forceUpdate();
  }

  private getUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }  
  
  //テナント初期化
  dialogTenantReset :boolean = false;
  generateSampleData: boolean = false;
  provisioningTemplate :string = null;
  public showTenantReset(){
    this.$api.issueGA4event(null, 'テナントの初期化');    
    this.provisioningTemplate = null; //標準
    this.dialogTenantReset = true;
  }

  public execTenantReset(){
    //リセット処理が成功するとログアウトする
    this.$api.startWaitCusor();
    this.$api.setRoadmapRatio(null);
    this.$api.execute(new Common.TenantResetQuery(this.generateSampleData, this.provisioningTemplate)).then(res=>{
      this.$api.closeWaitCursor();      
      this.$api.auth.logout();
      });     

  }    

  public logout(){
    //セッションを有効期限切れにする
    this.$api.multiFactorAuthenticate(new Common.MFALogoutQuery());
    //ログアウトする
    this.$api.auth.logout();
  }

  // お問い合わせフォーム実装
  public isShowInquiryForm: boolean = false;
  public isShowInquiryConfirm: boolean = false;
  public inquiryEmail: string = null;
  public inquiryCompany: string = null;
  public inquiryName: string = null;
  public inquiryType: Common.inquiryTypes = null;
  public inquiryContent: string = null;
  public inquiryTenantId: string = null;

  public showInquiryForm() {
    if (!this.inquiryEmail && !this.inquiryName && !this.inquiryCompany) {
      this.inquiryEmail = this.$api.auth.userId;
      this.inquiryName = this.$api.auth.userName;
      this.inquiryCompany = this.$api.license.tenantName;
      this.inquiryTenantId = this.$api.license.tenantId;
    }
    this.isShowInquiryForm = true;
  }

  public confirmInquiry(event: any) {
    // validate()の結果を&&で繋がずに格納することで、同時のリアルタイムバリデーションが可能になる
    // ※Textboxが複数行の時、必須に関してリアルタイムバリデーションがかからないのは仕様
    const val1: boolean = (this.$refs.inquiryEmail as Components.TextBox).validator.validate();
    const val2: boolean = (this.$refs.inquiryCompany as Components.TextBox).validator.validate();
    const val3: boolean = (this.$refs.inquiryName as Components.TextBox).validator.validate();
    const val4: boolean = (this.$refs.inquiryType as Components.ComboBox).validator.validate();
    const val5: boolean = (this.$refs.inquiryContent as Components.TextBox).validator.validate();
    const validation = val1 && val2 && val3 && val4 && val5;
    if (!validation) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    this.isShowInquiryConfirm = true;
  }

  public sendInquiry() {
    this.$api.execute(new Common.SendInquiryQuery(this.inquiryEmail, this.inquiryCompany, this.inquiryName, this.inquiryType, this.inquiryContent, this.inquiryTenantId)).then(() => {
      this.isShowInquiryForm = false;
      this.$api.modal.showDialog('お問い合わせ送信完了', 'この度はお問合せをいただきありがとうございました。\r\n後ほど、サポートデスクより回答させていただきます。\r\nしばらくお待ちくださいませ。');
      this.inquiryEmail = null;
      this.inquiryCompany = null;
      this.inquiryName = null;
      this.inquiryType = null;
      this.inquiryContent = null;
    });
  }

  public pushToSubscription() {
    this.isShowInquiryForm = false;
    this.$router.push('/system/Subscription');
  }
}
